module.exports = __webpack_public_path__ + "static/media/Melissa Schmidt.5aff9fcc.png";